module.exports = __webpack_public_path__ + "static/media/imgProduct3.858d2e93.png";